module.exports = __webpack_public_path__ + "static/media/sigil-1-stark.463e919e.png";